export default "__VITE_ASSET__d2304cbb__"